import { useState, useCallback } from 'react';
import uploadDocumentToDeal from '../api/deals/uploadDocumentToDeal';

const useDocumentUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [currentFileName, setCurrentFileName] = useState('');
  const [uploadQueue, setUploadQueue] = useState({ current: 0, total: 0 });
  const [error, setError] = useState(null);

  const upload = useCallback(async ({ dealId, fileTypeId, file, statusId, signed }) => {
    setUploading(true);
    setCurrentFileName(file?.name || 'Документ');
    setProgress({ loaded: 0, total: file?.size || 0, percent: 0 });
    setError(null);

    try {
      const result = await uploadDocumentToDeal({
        dealId,
        fileTypeId,
        file,
        statusId,
        signed,
        onProgress: (progressData) => {
          setProgress(progressData);
        }
      });
      return result;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setUploading(false);
      setProgress(null);
      setCurrentFileName('');
    }
  }, []);

  const uploadMultiple = useCallback(async (files) => {
    const validFiles = files.filter(f => f.file);
    if (validFiles.length === 0) return;

    setUploadQueue({ current: 0, total: validFiles.length });
    
    for (let i = 0; i < validFiles.length; i++) {
      setUploadQueue({ current: i + 1, total: validFiles.length });
      const { dealId, fileTypeId, file, statusId, signed } = validFiles[i];
      
      setUploading(true);
      setCurrentFileName(file?.name || 'Документ');
      setProgress({ loaded: 0, total: file?.size || 0, percent: 0 });

      try {
        await uploadDocumentToDeal({
          dealId,
          fileTypeId,
          file,
          statusId,
          signed,
          onProgress: (progressData) => {
            setProgress(progressData);
          }
        });
      } catch (err) {
        setError(err);
        throw err;
      }
    }

    setUploading(false);
    setProgress(null);
    setCurrentFileName('');
    setUploadQueue({ current: 0, total: 0 });
  }, []);

  const reset = useCallback(() => {
    setUploading(false);
    setProgress(null);
    setCurrentFileName('');
    setUploadQueue({ current: 0, total: 0 });
    setError(null);
  }, []);

  return {
    upload,
    uploadMultiple,
    uploading,
    progress,
    currentFileName,
    uploadQueue,
    error,
    reset
  };
};

export default useDocumentUpload;

